import React, { createContext, ReactNode, useContext } from "react";
import { KeyedMutator } from "swr";
import { GraphType, TestGraph } from "../types";

export interface GraphsContextType {
    originalGraphsValue: TestGraph[] | null;
    setOriginalGraphsValue: (value: TestGraph[] | null) => void;
    unsavedData: Array<{
        graph_id: TestGraph["graph_id"];
        changes: any | null;
    }>;
    graphs: TestGraph[] | undefined;
    onGraphsChange?: () => void;
    graphsType?: GraphType;
    loading: boolean;
    error: any | undefined;
    mutate: KeyedMutator<TestGraph[]>;
    refetchAdditionalData?: () => Promise<void>;
    refreshDataWithUnsavedChanges: (
        additionalData?: Record<string, Partial<TestGraph>>
    ) => Promise<TestGraph[]>;
}

const GraphsContext = createContext<GraphsContextType | null>(null);

// Define the props for the provider component
interface GraphsProviderProps {
    contextValue: GraphsContextType;
    children: ReactNode;
}

// Create the provider component
export const GraphsProvider: React.FC<GraphsProviderProps> = ({
    children,
    contextValue,
}) => {
    return (
        <GraphsContext.Provider value={contextValue}>
            {children}
        </GraphsContext.Provider>
    );
};

// Create the custom hook to use the context
export const useGraphs = (): GraphsContextType => {
    const context = useContext(GraphsContext);
    if (context === null) {
        throw new Error("useGraphs must be used within a GraphsProvider");
    }
    return context;
};
